<template>
    <img src="/images/promo/connect-features/money-with-wings.png"
     alt="Money With Wings" />
</template>

<script>
export default {};
</script>
